export default __webpack_public_path__ + "static/media/profile.eeb13719.png";